import React, {
  createContext,
  useContext,
  useEffect,
  useMemo,
  useState,
} from "react";
import {
  authTokenStore,
  AuthTokenState,
} from "../services/auth/tokenStore";

interface AuthContextValue {
  tokens: AuthTokenState;
  isAuthenticated: boolean;
  setTokens: (updates: Partial<AuthTokenState>) => void;
  clearTokens: () => void;
}

const defaultState = authTokenStore.getTokens();

const AuthContext = createContext<AuthContextValue>({
  tokens: defaultState,
  isAuthenticated: Boolean(defaultState.accessToken),
  setTokens: () => {},
  clearTokens: () => {},
});

export const AuthProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [tokens, setTokens] = useState<AuthTokenState>(
    authTokenStore.getTokens()
  );

  useEffect(() => authTokenStore.subscribe(setTokens), []);

  const value = useMemo<AuthContextValue>(
    () => ({
      tokens,
      isAuthenticated: Boolean(tokens.accessToken),
      setTokens: authTokenStore.setTokens,
      clearTokens: authTokenStore.clearTokens,
    }),
    [tokens]
  );

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export const useAuth = () => useContext(AuthContext);
